import React from "react";
import { useSelector } from "react-redux";

export default function LiveFooter() {
  const { stats } = useSelector((state) => state.table.table);
  const statsToShow = [
  {
    label: "Free",
    value: stats?.free || 0,
    color: "bg-[#525355]",
    dot: "bg-gray-300",
  },
  {
    label: "Reserved",
    value: stats?.reserved || 0,
    color: "bg-[#83c27e]",
    dot: "bg-green-700",
  },
  {
    label: "Checked-in / Waiting",
    value: stats?.checkin_waiting || 0,
    color: "bg-[#dfba23]",
    dot: "bg-yellow-600",
  },
  {
    label: "Occupied",
    value: stats?.occupied || 0,
    color: "bg-[#f95567]",
    dot: "bg-red-700",
  },
];

  return (
    <div className="rounded-md border border-neutral-700 w-full bg-black p-2 text-white">
      {/* Header */}
      {/* <div className="mb-5 flex flex-wrap items-center gap-6 text-base font-normal text-neutral-300">
        <div>
          Total Table - <span>{stats?.total_table}</span>
        </div>
        <div>
          Total Seats - <span>{stats?.total_seats}</span>
        </div>
      </div> */}

      {/* Status Cards */}
      <div className=" flex items-center gap-2">
        {statsToShow.map((item) => (
          <div
            key={item.label}
            className={` grow ${item.color} flex items-center justify-between rounded-lg px-2.5 py-1 tab-max:py-3 shadow-sm`}
          >
            <div className="flex items-center gap-2 text-sm font-medium">
              <span
                className={`h-2.5 w-2.5 rounded-full ${item.dot}`}
                aria-hidden
              />
              {item.label}
            </div>

            <div className="text-sm font-medium tracking-wide">
              {String(item.value).padStart(2, "0")}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
